var map = {
	"./Bsmart_02.gif": 17537,
	"./Loader.gif": 58195,
	"./arrow.png": 74931,
	"./arw.png": 17784,
	"./auto_pool.png": 89529,
	"./b1.png": 33936,
	"./b2.png": 81244,
	"./b3.png": 12463,
	"./b4.png": 88504,
	"./banbg.png": 80409,
	"./banimg.png": 94087,
	"./boxbg.png": 55825,
	"./busd.png": 36860,
	"./busd1.png": 22066,
	"./calender.png": 31433,
	"./copy.png": 72611,
	"./copy_green.png": 40883,
	"./dashban_bg.png": 6822,
	"./down_arw.png": 23402,
	"./faq.png": 20573,
	"./g1.png": 28130,
	"./g2.jpg": 74086,
	"./g2.png": 81079,
	"./g3.jpg": 85529,
	"./g3.png": 91848,
	"./g4.png": 57247,
	"./global.png": 20007,
	"./global_bg.png": 90904,
	"./global_bg1.png": 83617,
	"./grand.png": 91257,
	"./grand_1.png": 28964,
	"./information.png": 50807,
	"./information1.png": 33261,
	"./leadership.png": 60559,
	"./logo.png": 74427,
	"./logo.svg": 82835,
	"./logo_dark.svg": 21432,
	"./logout.jpg": 14466,
	"./logout.png": 26919,
	"./majestic.png": 12492,
	"./menu.png": 53325,
	"./menu1.png": 49909,
	"./metamask.png": 58843,
	"./minus.png": 4525,
	"./participants.png": 7236,
	"./plan_tree.png": 97737,
	"./planbg.png": 79899,
	"./plus.png": 97477,
	"./polygon_logo.png": 4453,
	"./popup_bg.png": 64145,
	"./primary.png": 66970,
	"./refferal.png": 34303,
	"./royal.png": 16648,
	"./seemore_arw.png": 7469,
	"./seemore_arw1.png": 17198,
	"./tick.png": 94307,
	"./tick1.png": 55647,
	"./tick2.png": 36848,
	"./tick_green.png": 86552,
	"./trustwallet.png": 89414,
	"./usd.png": 52751,
	"./usdt.png": 81080,
	"./user.png": 44353,
	"./user_1.png": 22856,
	"./user_2.png": 27833,
	"./user_3.png": 23420,
	"./user_3_blue.png": 47458,
	"./user_3_blue_empty.png": 6915,
	"./user_3_green.png": 8422,
	"./user_3_green_empty.png": 88573,
	"./user_3_violet.png": 14310,
	"./user_3_violet1.png": 22918,
	"./user_3_violet_empty.png": 14486,
	"./user_3_yellow.png": 39436,
	"./user_3_yellow_empty.png": 79536,
	"./user_prf.png": 85528,
	"./user_three.png": 91329,
	"./wallet.png": 82106,
	"./wallet_icon.png": 39073
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90990;